module.exports = __webpack_public_path__ + "static/img/shjtdj.0c532e9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/shjtdj.png
// module id = TSqE
// module chunks = 0